'use strict';

angular.module('mean.accounting').config(['$stateProvider',
  function ($stateProvider) {
    // Check if the user is connected
    var accountingConst = 'accounting';
    var checkLoggedin = function ($q, $timeout, $http, $location) {
      // Initialize a new promise
      var deferred = $q.defer();
      if (!localStorage.getItem('JWT')) {
        $location.url('/auth/login');
        $timeout(deferred.reject);
      } else {
        $timeout(deferred.resolve);
      }
      return deferred.promise;
    };

    $stateProvider
      .state(accountingConst, {
        url: '/' + accountingConst,
        templateUrl: accountingConst + '/views/accounting.html',
        resolve: {
          loggedin: checkLoggedin
        }
      })
  }
]);



// WEBPACK FOOTER //
// ./packages/custom/accounting/public/routes/accounting.js